



































import { grupo_centro } from "@/shared/dtos/grupo_centro";
import { MessageService } from "@/shared/services/message-service";
import grupo_centroModule from "@/store/modules/grupo_centro-module";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    MaterialCard: () => import("@/components/Cards/MaterialCard.vue"),
    Xbtn: () => import("@/components/buttons/x-btn.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class GruposCentrosFormulario extends Vue {
  created() {
    if (this.is_new()) {
      grupo_centroModule.onGetgrupo_centro(new grupo_centro());
    } else {
      grupo_centroModule.getgrupo_centro(this.$route.params.id);
    }
  }

  public get datasource() {
    return grupo_centroModule.grupo_centro;
  }
  public is_new() {
    return Number.parseInt(this.$route.params.id) === -1;
  }

  public aceptar() {
    this.$validator.validateAll().then((allOk) => {
      if (allOk) {
        if (this.is_new()) {
          grupo_centroModule
            .guardargrupo_centro(new grupo_centro(this.datasource))
            .then(() => this.cancelar());
        } else {
          grupo_centroModule
            .modificargrupo_centro(this.datasource)
            .then(() => this.cancelar());
        }
      }
    });
  }

  public cancelar() {
    this.$router.back();
  }

  eliminar() {
    MessageService.confirm(
      "¿Seguro que desea eliminar el grupo?",
      "Eliminar",
      (cb: boolean) => {
        if (cb) {
          grupo_centroModule
            .eliminargrupo_centro(this.datasource)
            .then(() => this.$router.back())
            .catch(() => {
              MessageService.toast(
                "No se ha podido eliminar, hay datos asociados a este grupo de centros",
                MessageService.TypeWarning
              );
            });
        }
      }
    );
  }
}
